export { ConnectedPaymentContainer as PaymentContainer } from './PaymentContainer'



// WEBPACK FOOTER //
// ./src/containers/Cart/Payment/index.js